import api from './api';
import app from './app';
import plugins from './plugins';
import useQuery from './useQuery';

export { api, app, app as config, plugins, useQuery };
export default { app, api, config: app, useQuery, plugins };
